import React from "react";

const BellIcon = () => {
  return (
    <img style={{ width: "25px", height: "25px" }} src="./img/icon-bell-white.svg" alt="notify" className="icon-file" />
  );
};

export default BellIcon;
